export type Envelope<TTopic = string, TData = unknown> = {
  eventId?: string;
  topic: TTopic;
  data: TData;
};

export function isErrorEnvelope(
  envelope: Envelope,
): envelope is Envelope<'error', { error: string }> {
  return envelope.topic === 'error';
}
